import { Typography } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { T } from '../../../../../Translations';

interface Props {
  internalName: string;
  onFieldShow: () => void;
}

function ShowInternalName({ internalName, onFieldShow }: Props) {
  return (
    <>
      <Typography
        color="black"
        variant="caption"
        fontWeight="semibold"
        className="ml-1 cursor-pointer"
      >
        {internalName}
      </Typography>
      <Typography
        color="teal"
        variant="caption"
        fontWeight="semibold"
        className="ml-2 cursor-pointer"
        onClick={onFieldShow}
      >
        <T kind="Edit" />
      </Typography>
    </>
  );
}

export default observer(ShowInternalName);
